

<div>
    <mat-card>
      <mat-card-content *ngIf="coupons && coupons.length > 0 else nocoupon">
        <div *ngFor="let c of coupons">
            <div class="row">
                <div class="col-12">
            <h3> Coupon Code: </h3> <a> {{c.code}} </a>
                </div>
          </div>
          <div class="row">
              <div class="col-12">
              <h3> Description </h3>
              <p [innerHTML]='c.description'> </p>
              
              </div>
          </div>
          <div class="row">
              <div class="col-12">
                  Discount = {{c.discount}} %
              </div>     
          </div>
          <div class="row">
              <div class="col-12">
                 Total amount should be Minimum Rs. {{c.minval}}.
              </div>  
          </div>
          <div class="row">
              <div class="col-12">
              <a (click)="addCoupon(c.minval, c.discount, c.id)"> Add </a>
              </div>
          </div>
          
        </div>
      </mat-card-content>
    </mat-card>
  </div>
    
    
    <ng-template #nocoupon>
        <div class="row"  *ngIf="coupons && coupons.length==0">
         <div class="col-12 text-centre">
             <h2 style="color:#9b7544; font-style: open sans">No Coupons Available</h2>
         </div>
      </div>
    
    
    </ng-template>
    